// import { AuthenticationProvider } from "./components/AuthenticationProvider";

import { Provider } from 'react-redux';
import { I18nextProvider } from "react-i18next";

import RouterProvider from './routes';
import { ThemeProvider } from '@mui/material/styles';
import SettingsProvider from './components/Settings/components/SettingsProvider';

import theme from './overrides/theme';
import store from './store';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import SentryProvider from './components/Sentry/sentry';
import LanguageProvider from './components/Language/components/LanguageProvider';
import ErpFeaturesProvider from './components/ErpFeatures/components/ErpFeaturesProvider';


const queryClient = new QueryClient();

const App = (props) => {
  
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <ErpFeaturesProvider>
          <SettingsProvider>
            <SentryProvider>
              <LanguageProvider>
                <ThemeProvider theme={theme}>
                  <RouterProvider />
                </ThemeProvider>
              </LanguageProvider>
            </SentryProvider>
          </SettingsProvider>
        </ErpFeaturesProvider>
      </Provider>
    </QueryClientProvider>
  );
};

export default App;
